import { AppBar, Box, Hidden, IconButton, SvgIcon, Toolbar, Tooltip, useTheme } from '@mui/material';
import { styled } from '@mui/material/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { Menu as MenuIcon } from 'react-feather';
import { Link as RouterLink } from 'react-router-dom';
import Iconify from 'src/components/Iconify';
import Logo from 'src/components/Logo';
import { THEMES } from 'src/constants';
import useSettings from 'src/hooks/useSettings';
import { ROOT_APP } from 'src/routes/paths';
import Account from './Account';

const PREFIX = 'TopBar';

const classes = {
  root: `${PREFIX}-root`,
  toolbar: `${PREFIX}-toolbar`,
  logo: `${PREFIX}-logo`
};

const StyledAppBar = styled(AppBar)((
  {
    theme
  }
) => ({
  [`&.${classes.root}`]: {
    zIndex: theme.zIndex.drawer + 100,
    ...(theme.name === THEMES.LIGHT
      ? {
          boxShadow: 'none',
          backgroundColor: theme.palette.primary.main,
        }
      : {}),
    ...(theme.name === THEMES.ONE_DARK
      ? {
          backgroundColor: theme.palette.background.default,
        }
      : {}),
  },

  [`& .${classes.toolbar}`]: {
    minHeight: 64,
  },

  [`& .${classes.logo}`]: {
    height: 40,
  }
}));

const TopBar = ({ className, onMobileNavOpen, ...rest }) => {

  const theme = useTheme();

  const { settings, saveSettings } = useSettings();

  return (
    <StyledAppBar className={clsx(classes.root, className)} {...rest}>
      <Toolbar className={classes.toolbar}>
        <Hidden lgUp>
          <IconButton color="inherit" onClick={onMobileNavOpen} size="large">
            <SvgIcon fontSize="small">
              <MenuIcon />
            </SvgIcon>
          </IconButton>
        </Hidden>
        <Hidden lgDown>
          <RouterLink to={ROOT_APP}>
            <Logo className={classes.logo} />
          </RouterLink>
        </Hidden>
        <Box ml={2} flexGrow={1} />
        <Box mr={2}>
          <Tooltip title={settings.theme === THEMES.LIGHT ? 'Change to dark mode' : 'Change to light mode'}>
            <IconButton
              onClick={() => saveSettings({ theme: settings.theme === THEMES.LIGHT ? THEMES.ONE_DARK : THEMES.LIGHT })}
              size="large">
              <Iconify
                icon={
                  settings.theme === THEMES.LIGHT
                    ? 'material-symbols:dark-mode-outline'
                    : 'material-symbols:light-mode-outline'
                }
                width={20}
                height={20}
                color={theme.palette.common.white}
              />
            </IconButton>
          </Tooltip>
        </Box>
        <Box ml={2}>
          <Account />
        </Box>
      </Toolbar>
    </StyledAppBar>
  );
};

TopBar.propTypes = {
  className: PropTypes.string,
  onMobileNavOpen: PropTypes.func,
};

export default TopBar;
